(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["admin-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-admin-panel]');
    if (!root) return;
    var API = (root.getAttribute('data-admin-api-base') || '').replace(/\/$/, '');
    var STORAGE_KEY = 'puracanvas.admin.token';

    var els = {
      status: root.querySelector('[data-admin-status]'),
      login: root.querySelector('[data-admin-login]'),
      main: root.querySelector('[data-admin-main]'),
      grid: root.querySelector('[data-admin-stats-grid]'),
      topUsers: root.querySelector('[data-admin-top-users]'),
      usageJson: root.querySelector('[data-admin-usage-json]'),
      dataJson: root.querySelector('[data-admin-data-json]'),
      gallery: root.querySelector('[data-admin-gallery]'),
      imagesCount: root.querySelector('[data-admin-images-count]'),
      err: root.querySelector('[data-admin-error]'),
      refreshBtn: root.querySelector('[data-admin-refresh]'),
      setLimitBtn: root.querySelector('[data-admin-set-limit-key]'),
      logoutBtn: root.querySelector('[data-admin-logout]'),
      loginForm: root.querySelector('[data-admin-login]'),
      tokenInput: root.querySelector('#admin-token-input'),
    };

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function escapeAttr(s) { return escapeHtml(s); }

    function getToken() {
      try { return localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
    }
    function setToken(v) {
      try { if (v) localStorage.setItem(STORAGE_KEY, v); else localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }

    function showLogin(msg) {
      els.login.hidden = false;
      els.main.hidden = true;
      els.status.textContent = msg || 'Enter your admin token.';
    }
    function showMain() {
      els.login.hidden = true;
      els.main.hidden = false;
      els.status.textContent = 'Signed in.';
    }
    function showError(msg) {
      els.err.hidden = false;
      els.err.textContent = msg;
    }
    function clearError() {
      els.err.hidden = true;
      els.err.textContent = '';
    }

    function apiFetch(path) {
      var token = getToken();
      return fetch(API + path, {
        headers: token ? { Authorization: 'Bearer ' + token } : {},
      }).then(function (r) {
        if (r.status === 401) throw new Error('UNAUTHORIZED');
        if (r.status === 503) throw new Error('ADMIN_TOKEN not set on the server.');
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }

    function renderStats(s) {
      var cards = [
        { label: 'Devices', value: s.devices },
        { label: 'Customers', value: s.customers },
        { label: 'Total generations', value: s.total_generations },
        { label: 'Image limit / user', value: s.device_image_limit },
        { label: 'Uploaded files', value: s.files && s.files.uploads },
        { label: 'Generated files', value: s.files && s.files.generated_images },
      ];
      els.grid.innerHTML = cards
        .map(function (c) {
          return (
            '<div class="admin-panel__stat">' +
            '<div class="admin-panel__stat-value">' + (c.value == null ? '—' : c.value) + '</div>' +
            '<div class="admin-panel__stat-label">' + c.label + '</div>' +
            '</div>'
          );
        })
        .join('');

      var rows = (s.top_users || []).map(function (u) {
        var k = escapeHtml(u.key || '');
        var override = u.limit_override ? ' <span class="admin-panel__pill admin-panel__pill--idx" title="Per-user limit override">limit ' + u.limit_override + '</span>' : '';
        return (
          '<div class="admin-panel__top-row">' +
            '<span class="admin-panel__top-key">' + k + override + '</span>' +
            '<span class="admin-panel__top-actions">' +
              '<span>' + u.count + '</span>' +
              '<button type="button" class="admin-panel__row-btn" data-admin-set-limit="' + escapeAttr(u.key || '') + '">Set limit</button>' +
            '</span>' +
          '</div>'
        );
      });
      els.topUsers.innerHTML = rows.length ? rows.join('') : '<em>No usage recorded yet.</em>';
      els.topUsers.querySelectorAll('[data-admin-set-limit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          promptSetLimit(btn.getAttribute('data-admin-set-limit'));
        });
      });
    }

    function promptSetLimit(key) {
      if (!key) return;
      var raw = window.prompt(
        'Set image-generation limit for "' + key + '"\n(Enter 0 to clear override and use the default)',
        '100'
      );
      if (raw == null) return;
      var n = parseInt(String(raw).trim(), 10);
      if (isNaN(n) || n < 0) { alert('Please enter a non-negative integer.'); return; }
      var token = getToken();
      fetch(API + '/admin/set_limit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify({ key: key, limit: n }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function () { load(); })
        .catch(function (e) { showError('Failed to set limit: ' + e.message); });
    }

    function renderGallery(entries) {
      if (!els.gallery) return;
      var list = Array.isArray(entries) ? entries : [];
      if (els.imagesCount) {
        els.imagesCount.textContent = list.length
          ? '(' + list.length + ' most recent)'
          : '(none yet)';
      }
      if (!list.length) {
        els.gallery.innerHTML =
          '<div class="admin-panel__empty">No generated images yet.</div>';
        return;
      }
      els.gallery.innerHTML = list
        .map(function (entry, idx) {
          var imageUrl = entry && entry.imageUrl ? String(entry.imageUrl) : '';
          var refUrl = entry && entry.upload_url ? String(entry.upload_url) : '';
          var orient = entry && entry.orientation ? String(entry.orientation) : '';
          var prompt = entry && entry.prompt_final ? String(entry.prompt_final) : '';
          return (
            '<article class="admin-panel__card">' +
              (imageUrl
                ? '<img class="admin-panel__card-img" src="' + escapeAttr(imageUrl) + '" alt="Generated preview" loading="lazy" decoding="async">'
                : '<div class="admin-panel__card-img"></div>') +
              '<div class="admin-panel__card-body">' +
                '<div class="admin-panel__card-meta">' +
                  '<span class="admin-panel__pill admin-panel__pill--idx">#' + (idx + 1) + '</span>' +
                  (orient ? '<span class="admin-panel__pill">' + escapeHtml(orient) + '</span>' : '') +
                  (refUrl
                    ? '<a class="admin-panel__ref-link" href="' + escapeAttr(refUrl) + '" target="_blank" rel="noopener noreferrer" title="Open reference image"><img src="' + escapeAttr(refUrl) + '" alt="" loading="lazy">ref</a>'
                    : '') +
                '</div>' +
                (prompt
                  ? '<p class="admin-panel__prompt" data-admin-prompt>' + escapeHtml(prompt) + '</p>' +
                    '<button type="button" class="admin-panel__prompt-toggle" data-admin-prompt-toggle hidden>Show more</button>'
                  : '') +
              '</div>' +
            '</article>'
          );
        })
        .join('');

      // Wire up "Show more / less" toggles for clamped prompts
      var cards = els.gallery.querySelectorAll('.admin-panel__card');
      cards.forEach(function (card) {
        var p = card.querySelector('[data-admin-prompt]');
        var btn = card.querySelector('[data-admin-prompt-toggle]');
        if (!p || !btn) return;
        // Show the toggle only if the prompt is actually clamped.
        if (p.scrollHeight > p.clientHeight + 2) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var expanded = p.classList.toggle('is-expanded');
            btn.textContent = expanded ? 'Show less' : 'Show more';
          });
        }
      });
    }

    function load() {
      clearError();
      Promise.all([
        apiFetch('/admin/stats'),
        apiFetch('/admin/usage'),
        apiFetch('/admin/data_json'),
      ])
        .then(function (results) {
          renderStats(results[0]);
          els.usageJson.textContent = JSON.stringify(results[1], null, 2);
          els.dataJson.textContent = JSON.stringify(results[2], null, 2);
          renderGallery(results[2]);
        })
        .catch(function (e) {
          if (e.message === 'UNAUTHORIZED') {
            setToken('');
            showLogin('Token rejected. Try again.');
          } else {
            showError(e.message);
          }
        });
    }

    function tryAuth() {
      if (!getToken()) { showLogin(); return; }
      apiFetch('/admin/check')
        .then(function () { showMain(); load(); })
        .catch(function () { setToken(''); showLogin('Token expired or wrong. Re-enter it.'); });
    }

    els.loginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = (els.tokenInput.value || '').trim();
      if (!t) return;
      setToken(t);
      els.tokenInput.value = '';
      tryAuth();
    });
    els.refreshBtn.addEventListener('click', load);
    if (els.setLimitBtn) {
      els.setLimitBtn.addEventListener('click', function () {
        var key = window.prompt('Usage key (e.g. web-4zixhj or customer-12345):');
        if (key) promptSetLimit(key.trim());
      });
    }
    els.logoutBtn.addEventListener('click', function () {
      setToken('');
      showLogin('Signed out.');
    });

    tryAuth();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
